export const SET_BRANDS = "SET_BRANDS";
export const SET_MODELS = "SET_MODELS";
export const SET_SERVICES = "SET_SERVICES";
export const SET_DEALERS = "SET_DEALERS";
export const SET_FETCHING = "SET_FETCHING";
export const SET_MODEL = "SET_MODEL";
export const SET_SERVICE = "SET_SERVICE";
export const SET_RECOMENDATIONS = "SET_RECOMENDATIONS"
